import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import JourneyAcademy from './JourneyAcademy';
import CourseTagProp from '../../commonComponents/propTypes/CourseTagProp';
import PriceRangeProp from '../academy/propTypes/PriceRangeProp';
import MetaContext from '../../contextProviders/MetaContext';

function JourneysAcademyWrapper(props) {
  const { t, languages, currencies, tags, applyFilters, priceRange } = props;
  const { userPortalMenus } = useContext(MetaContext);
  const title =
    userPortalMenus.find(u => u.type === 'academy')?.name ||
    t('academy_head_title');
  const hasWhiteBar = true;
  const filter = 'journeys';

  return (
    <Title title={t('journey_head_title')}>
      <ContentContainer>
        <SubHeader title={title} hasWhiteBar={hasWhiteBar} filter={filter} />
        <TopicBanner />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <JourneyAcademy
                languages={languages}
                currencies={currencies}
                tags={tags}
                applyFilters={applyFilters}
                priceRange={priceRange}
              />
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

JourneysAcademyWrapper.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape(CourseTagProp.propType)),
  applyFilters: PropTypes.bool,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

JourneysAcademyWrapper.defaultProps = {
  tags: [],
  applyFilters: false,
};

export default translate(JourneysAcademyWrapper);
